/* START_MODULE_CONTRACT
 * PURPOSE: Frontend API client для рабочего календаря (working time).
 * SCOPE: HTTP-вызовы /api/calendar/working_time.
 * DEPENDS: M-FE-API
 * LINKS: M-FE-API, V-M-FE-API, M-CALENDAR
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * getWorkingTime - рабочее время в диапазоне дат.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-02 - GRACE coverage: function contracts и парные END_METHOD.
 * END_CHANGE_SUMMARY
 */

import apiClient from './apiClient';

/* START_METHOD_getWorkingTime */
/* START_CONTRACT: getWorkingTime
 * PURPOSE: Получить рабочее время (рабочие/выходные дни) в диапазоне.
 * INPUTS: { from: string - дата ISO, to: string - дата ISO, signal: AbortSignal }
 * OUTPUTS: { Promise<AxiosResponse> - GET working_time }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-CALENDAR
 * END_CONTRACT: getWorkingTime
 */
export function getWorkingTime(from, to, signal) {
  return apiClient.get('/api/calendar/working_time', {
    params: { from, to },
    signal,
  });
}
/* END_METHOD_getWorkingTime */
